<template>
  <AppliedProjects />
</template>

<script>
import AppliedProjects from '../components/AppliedProjects.vue';
export default {
  components: {
    AppliedProjects,
  },
  data() {
    return {
      disableCard: false,
    };
  },
}
</script>
